import dayjs from 'utils/dayjsConfig';
import { getCurrentSameDateRange, semeterDateByYear } from 'utils/methods/math';

export const getSemesterDateRange = (semesterString, parentOrgId) => {
  if (!semesterString || typeof semesterString !== 'string') return getCurrentSameDateRange(parentOrgId);
  const parts = semesterString.toLowerCase().split(' ');
  const semNum = parseInt(parts[1], 10);
  const year = parts[3];
  if (parts.length < 4 || !year || Number.isNaN(semNum)) return getCurrentSameDateRange(parentOrgId);
  const dates = semeterDateByYear(year, parentOrgId);
  if (semNum === 1) {
    return {
      from_date: dates.sem1StartDate.toISOString(),
      end_date: dates.sem1EndDate.toISOString()
    };
  }
  return {
    from_date: dates.sem2StartDate.toISOString(),
    end_date: dates.sem2EndDate.toISOString()
  };
};

export const generateDateRanges = (activeSemParam, parentOrgId) => {
  const semDateRange = activeSemParam ? getSemesterDateRange(activeSemParam, parentOrgId) : getCurrentSameDateRange(parentOrgId);
  const current_sem = `${semDateRange.from_date}/${semDateRange.end_date}`;
  const now = dayjs();
  const startOfCurrentWeek = now.startOf('isoWeek');
  const endOfCurrentWeek = now.endOf('isoWeek');
  const lastWeek = now.subtract(7, 'day');
  const startOfLastWeek = lastWeek.startOf('isoWeek');
  const endOfLastWeek = lastWeek.endOf('isoWeek');
  const startOfCurrentMonth = now.startOf('month');
  const endOfCurrentMonth = now.endOf('month');
  const lastMonth = now.subtract(30, 'day');
  const startOfLastMonth = lastMonth.startOf('month');
  const endOfLastMonth = lastMonth.endOf('month');
  const last30DaysStart = now.subtract(29, 'day').startOf('day');
  const last30DaysEnd = now.endOf('day');
  return [
    { label: 'Current semester', value: current_sem },
    { label: 'Today', value: `${now.startOf('day').toISOString()}/${now.endOf('day').toISOString()}` },
    { label: 'Current week', value: `${startOfCurrentWeek.toISOString()}/${endOfCurrentWeek.toISOString()}` },
    { label: 'Last week', value: `${startOfLastWeek.toISOString()}/${endOfLastWeek.toISOString()}` },
    { label: 'Current month', value: `${startOfCurrentMonth.toISOString()}/${endOfCurrentMonth.toISOString()}` },
    { label: 'Last month', value: `${startOfLastMonth.toISOString()}/${endOfLastMonth.toISOString()}` },
    { label: 'Last 30 days', value: `${last30DaysStart.toISOString()}/${last30DaysEnd.toISOString()}` },
  ];
};

export const parseDateRangeValue = (rangeValue) => {
  if (!rangeValue || typeof rangeValue !== 'string') return null;
  const [fromStr, endStr] = rangeValue.split('/');
  if (!fromStr || !endStr) return null;
  const start = new Date(fromStr.trim());
  const end = new Date(endStr.trim());
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return null;
  return { start, end };
};

export const areDateRangesEqual = (range1, range2) => {
  const parsed1 = parseDateRangeValue(range1);
  const parsed2 = parseDateRangeValue(range2);
  if (!parsed1 || !parsed2) return false;
  const start1 = dayjs(parsed1.start).startOf('day').valueOf();
  const end1 = dayjs(parsed1.end).startOf('day').valueOf();
  const start2 = dayjs(parsed2.start).startOf('day').valueOf();
  const end2 = dayjs(parsed2.end).startOf('day').valueOf();
  return start1 === start2 && end1 === end2;
};

export const getDateOnlyRangeBounds = (rangeValue) => {
  const parsed = parseDateRangeValue(rangeValue);
  if (!parsed) return null;
  return {
    start: dayjs(parsed.start).startOf('day').toDate(),
    end: dayjs(parsed.end).endOf('day').toDate()
  };
};

export const getDefaultGradeTableDateRange = (activeSem, parentOrgId) => {
  const range = getSemesterDateRange(activeSem, parentOrgId);
  return `${range.from_date}/${range.end_date}`;
};
